module.exports = "//public.zight.com/packs/media/images/onboarding/download-mac-4f746ba7d1aa71523b538ceb5b29abe3.svg";